
// =========================
// FETCH ALL
// =========================
export const FETCH_ORDRE_MISSION_REQUEST = "FETCH_ORDRE_MISSION_REQUEST";
export const FETCH_ORDRE_MISSION_SUCCESS = "FETCH_ORDRE_MISSION_SUCCESS";
export const FETCH_ORDRE_MISSION_FAIL = "FETCH_ORDRE_MISSION_FAIL";

// =========================
// GET BY ID
// =========================
export const FETCH_ORDRE_MISSION_BY_ID_REQUEST = "FETCH_ORDRE_MISSION_BY_ID_REQUEST";
export const FETCH_ORDRE_MISSION_BY_ID_SUCCESS = "FETCH_ORDRE_MISSION_BY_ID_SUCCESS";
export const FETCH_ORDRE_MISSION_BY_ID_FAIL = "FETCH_ORDRE_MISSION_BY_ID_FAIL";

// =========================
// CREATE
// =========================
export const CREATE_ORDRE_MISSION_REQUEST = "CREATE_ORDRE_MISSION_REQUEST";
export const CREATE_ORDRE_MISSION_SUCCESS = "CREATE_ORDRE_MISSION_SUCCESS";
export const CREATE_ORDRE_MISSION_FAIL = "CREATE_ORDRE_MISSION_FAIL";

// =========================
// UPDATE
// =========================
export const UPDATE_ORDRE_MISSION_REQUEST = "UPDATE_ORDRE_MISSION_REQUEST";
export const UPDATE_ORDRE_MISSION_SUCCESS = "UPDATE_ORDRE_MISSION_SUCCESS";
export const UPDATE_ORDRE_MISSION_FAIL = "UPDATE_ORDRE_MISSION_FAIL";

// =========================
// DELETE
// =========================
export const DELETE_ORDRE_MISSION_REQUEST = "DELETE_ORDRE_MISSION_REQUEST";
export const DELETE_ORDRE_MISSION_SUCCESS = "DELETE_ORDRE_MISSION_SUCCESS";
export const DELETE_ORDRE_MISSION_FAIL = "DELETE_ORDRE_MISSION_FAIL";

// =========================
// FETCH ACTIFS
// =========================
export const FETCH_ORDRE_MISSION_ACTIFS_REQUEST = "FETCH_ORDRE_MISSION_ACTIFS_REQUEST";
export const FETCH_ORDRE_MISSION_ACTIFS_SUCCESS = "FETCH_ORDRE_MISSION_ACTIFS_SUCCESS";
export const FETCH_ORDRE_MISSION_ACTIFS_FAIL = "FETCH_ORDRE_MISSION_ACTIFS_FAIL";

// =========================
// FETCH EN COURS
// =========================
export const FETCH_ORDRE_MISSION_EN_COURS_REQUEST = "FETCH_ORDRE_MISSION_EN_COURS_REQUEST";
export const FETCH_ORDRE_MISSION_EN_COURS_SUCCESS = "FETCH_ORDRE_MISSION_EN_COURS_SUCCESS";
export const FETCH_ORDRE_MISSION_EN_COURS_FAIL = "FETCH_ORDRE_MISSION_EN_COURS_FAIL";

// =========================
// FETCH BY PERIOD
// =========================
export const FETCH_ORDRE_MISSION_BY_PERIOD_REQUEST = "FETCH_ORDRE_MISSION_BY_PERIOD_REQUEST";
export const FETCH_ORDRE_MISSION_BY_PERIOD_SUCCESS = "FETCH_ORDRE_MISSION_BY_PERIOD_SUCCESS";
export const FETCH_ORDRE_MISSION_BY_PERIOD_FAIL = "FETCH_ORDRE_MISSION_BY_PERIOD_FAIL";

// =========================
// LOADING / ERROR
// =========================
export const SET_ORDRE_MISSION_LOADING = "SET_ORDRE_MISSION_LOADING";
export const CLEAR_ORDRE_MISSION_ERROR = "CLEAR_ORDRE_MISSION_ERROR";

// =========================
// ACTION CREATORS
// =========================
export const setOrdreMissionLoading = (loading) => ({
    type: SET_ORDRE_MISSION_LOADING,
    payload: loading,
});

export const clearOrdreMissionError = () => ({
    type: CLEAR_ORDRE_MISSION_ERROR,
});

// FETCH ALL
export const fetchOrdreMissionRequest = () => ({ type: FETCH_ORDRE_MISSION_REQUEST });
export const fetchOrdreMissionSuccess = (data) => ({ type: FETCH_ORDRE_MISSION_SUCCESS, payload: data });
export const fetchOrdreMissionFail = (error) => ({ type: FETCH_ORDRE_MISSION_FAIL, payload: error });

// FETCH BY ID
export const fetchOrdreMissionByIdRequest = (id) => ({ type: FETCH_ORDRE_MISSION_BY_ID_REQUEST, payload: id });
export const fetchOrdreMissionByIdSuccess = (data) => ({ type: FETCH_ORDRE_MISSION_BY_ID_SUCCESS, payload: data });
export const fetchOrdreMissionByIdFail = (error) => ({ type: FETCH_ORDRE_MISSION_BY_ID_FAIL, payload: error });

// CREATE
export const createOrdreMissionRequest = (payload) => ({ type: CREATE_ORDRE_MISSION_REQUEST, payload });
export const createOrdreMissionSuccess = (created) => ({ type: CREATE_ORDRE_MISSION_SUCCESS, payload: created });
export const createOrdreMissionFail = (error) => ({ type: CREATE_ORDRE_MISSION_FAIL, payload: error });

// UPDATE
export const updateOrdreMissionRequest = (id, payload) => ({
    type: UPDATE_ORDRE_MISSION_REQUEST,
    payload: { id, payload }
});
export const updateOrdreMissionSuccess = (updated) => ({ type: UPDATE_ORDRE_MISSION_SUCCESS, payload: updated });
export const updateOrdreMissionFail = (error) => ({ type: UPDATE_ORDRE_MISSION_FAIL, payload: error });

// DELETE
export const deleteOrdreMissionRequest = (id) => ({ type: DELETE_ORDRE_MISSION_REQUEST, payload: id });
export const deleteOrdreMissionSuccess = (id) => ({ type: DELETE_ORDRE_MISSION_SUCCESS, payload: id });
export const deleteOrdreMissionFail = (error) => ({ type: DELETE_ORDRE_MISSION_FAIL, payload: error });

// FETCH ACTIFS
export const fetchOrdreMissionActifsRequest = () => ({ type: FETCH_ORDRE_MISSION_ACTIFS_REQUEST });
export const fetchOrdreMissionActifsSuccess = (data) => ({ type: FETCH_ORDRE_MISSION_ACTIFS_SUCCESS, payload: data });
export const fetchOrdreMissionActifsFail = (error) => ({ type: FETCH_ORDRE_MISSION_ACTIFS_FAIL, payload: error });

// FETCH EN COURS
export const fetchOrdreMissionEnCoursRequest = () => ({ type: FETCH_ORDRE_MISSION_EN_COURS_REQUEST });
export const fetchOrdreMissionEnCoursSuccess = (data) => ({ type: FETCH_ORDRE_MISSION_EN_COURS_SUCCESS, payload: data });
export const fetchOrdreMissionEnCoursFail = (error) => ({ type: FETCH_ORDRE_MISSION_EN_COURS_FAIL, payload: error });

// FETCH BY PERIOD
export const fetchOrdreMissionByPeriodRequest = (dateDebut, dateFin) => ({
    type: FETCH_ORDRE_MISSION_BY_PERIOD_REQUEST,
    payload: { dateDebut, dateFin }
});
export const fetchOrdreMissionByPeriodSuccess = (data) => ({ type: FETCH_ORDRE_MISSION_BY_PERIOD_SUCCESS, payload: data });
export const fetchOrdreMissionByPeriodFail = (error) => ({ type: FETCH_ORDRE_MISSION_BY_PERIOD_FAIL, payload: error });